import type { Role } from '@/entities/user';

export const adminsAccessRoles = ['admin'] as const satisfies readonly Role[];
